export default __webpack_public_path__ + "static/media/logojewel.e4520594.png";